import { buildEventId } from '~/utilities/metaCapiEventIds'

function trackWhenReady(eventName, eventId, customData) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  window.fbq('track', eventName, customData ?? {}, { eventID: eventId })
}

export function trackMetaBrowserLead(ticketId) {
  trackWhenReady('Lead', buildEventId('traffic_submit', ticketId))
}

export function trackMetaBrowserPurchase(ticketId, value) {
  if (!Number.isFinite(value) || value <= 0) return
  trackWhenReady('Purchase', buildEventId('traffic_converted', ticketId), {
    value,
    currency: 'USD',
  })
}

/** Fire only on first payment-method save (hadPaymentMethod must be captured before sync). */
export function trackMetaBrowserAddPaymentInfo(userId, hadPaymentMethod) {
  if (hadPaymentMethod) return
  trackWhenReady('AddPaymentInfo', buildEventId('payment_info_saved', userId))
}
